import { Environment, getEnvironmentByHostname } from '@/utils/environmentByHostname';

interface PostHogConfig {
    apiKey: string;
    apiHost: string;
}

const POSTHOG_API_HOST = 'https://d.optoscale.no';

const POSTHOG_CONFIG: Record<Environment, PostHogConfig> = {
    [Environment.Production]: {
        apiKey: 'phc_wc82gZqgoWwOvUvtY4xN0cZbO9ykT8nDyiO2rfyu0A5',
        apiHost: POSTHOG_API_HOST,
    },
    [Environment.Staging]: {
        apiKey: 'phc_wc82gZqgoWwOvUvtY4xN0cZbO9ykT8nDyiO2rfyu0A5',
        apiHost: POSTHOG_API_HOST,
    },
    [Environment.Development]: {
        apiKey: 'phc_wc82gZqgoWwOvUvtY4xN0cZbO9ykT8nDyiO2rfyu0A5',
        apiHost: POSTHOG_API_HOST,
    },
};

export function getPostHogConfig(): PostHogConfig {
    return POSTHOG_CONFIG[getEnvironmentByHostname()];
}
